import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold" }, "Bauvorhaben:*", -1)
const _hoisted_3 = {
  key: 1,
  class: "w-full h-full rounded-l-lg flex flex-col outline-none p-2"
}
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = { class: "w-full flex" }
const _hoisted_6 = {
  key: 2,
  class: "h-full w-10 flex items-center justify-center rounded-r-lg"
}
const _hoisted_7 = {
  key: 3,
  class: "w-10 h-full flex items-center justify-center rounded-r-lg"
}
const _hoisted_8 = {
  key: 0,
  class: "w-full min-h-52 h-52 bg-zewotherm-lightgrey rounded-lg p-2 flex flex-col overflow-y-auto"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "font-bold" }
const _hoisted_11 = { class: "w-full flex" }

import Construction from '@/interfaces/construction/Construction'
import { useAddProject } from '@/store/addProject'
import { IonIcon, IonModal } from '@ionic/vue'
import axios from 'axios'
import { add, closeCircle } from 'ionicons/icons'
import { Ref, ref, watch } from 'vue'
import { useCompany } from '@/store/company'
import AddConstructionProjectPage from '../AddConstructionProjectPage.vue'
import { useCurrentUser } from '@/store/currentUser'


export default /*#__PURE__*/_defineComponent({
  __name: 'ConstructionInput',
  setup(__props) {

const addProjectStore = useAddProject()
const companyStore = useCompany()
const searchConstruction = ref("")
const constructionToChoose: Ref<Construction[]> = ref([])
const openModalConstruction = ref(false)
const currentUserStore = useCurrentUser()

watch(() => searchConstruction.value, async(newValue, oldValue) => {
  if(newValue.length >= 3) {
    const response = await axios.get(process.env.VUE_APP_PROJECT_API_BASE_URL + "construction/?search=" + newValue + "&company=" + companyStore.activeCompany.id.toString(), {
      headers: {
        Authorization: 'Bearer ' + currentUserStore.jwtKey
      }
    })
    constructionToChoose.value = response.data.data
  } else {
    constructionToChoose.value = []
  }
})

function clearConstruction() {
  addProjectStore.setProjectActiveDataConstruction(null)
}

function setConstruction(construction: Construction) {
  addProjectStore.setProjectActiveDataConstruction(construction)
  constructionToChoose.value = []
  searchConstruction.value = ""
}

async function getAndSetConstructionWithId(event: any) {
  if(!event.detail.data) return
  const response = await axios.get(process.env.VUE_APP_PROJECT_API_BASE_URL + "construction/" + event.detail.data + "/?company=" + companyStore.activeCompany.id, {
    headers: {
      Authorization: 'Bearer ' + currentUserStore.jwtKey
    }
  })
  setConstruction(response.data.data)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonModal), {
      onWillDismiss: _cache[0] || (_cache[0] = ($event: any) => (openModalConstruction.value = false)),
      onDidDismiss: _cache[1] || (_cache[1] = ($event: any) => (getAndSetConstructionWithId($event))),
      "is-open": openModalConstruction.value,
      "swipe-to-close": true
    }, {
      default: _withCtx(() => [
        _createVNode(AddConstructionProjectPage)
      ]),
      _: 1
    }, 8, ["is-open"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", {
        class: _normalizeClass(["flex flex-row min-h-min h-10 bg-zewotherm-lightgrey rounded-lg my-1", [_unref(addProjectStore).errorResponse.construction && _unref(addProjectStore).errorResponse.construction.length > 0 ? 'border-2 border-red-500' : '']])
      }, [
        (_unref(addProjectStore).projectActiveData.construction == null)
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 0,
              placeholder: "Suche",
              enterkeyhint: "next",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchConstruction).value = $event)),
              class: "w-0 placeholder-zewotherm-grey flex-grow h-full bg-zewotherm-lightgrey border p-2 font-bold rounded-l-lg outline-none"
            }, null, 512)), [
              [_vModelText, searchConstruction.value]
            ])
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("label", _hoisted_4, _toDisplayString(_unref(addProjectStore).projectActiveData.construction?.name), 1),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("label", null, _toDisplayString(_unref(addProjectStore).projectActiveData.construction?.zip) + " ", 1),
                _createElementVNode("label", null, _toDisplayString(_unref(addProjectStore).projectActiveData.construction?.city) + ", ", 1),
                _createElementVNode("label", null, _toDisplayString(_unref(addProjectStore).projectActiveData.construction?.country), 1)
              ])
            ])),
        (_unref(addProjectStore).projectActiveData.construction != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_unref(IonIcon), {
                icon: _unref(closeCircle),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (clearConstruction())),
                class: "w-6 h-6 cursor-pointer"
              }, null, 8, ["icon"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_unref(IonIcon), {
                icon: _unref(add),
                onClick: _cache[4] || (_cache[4] = ($event: any) => (openModalConstruction.value = true)),
                class: "w-8 h-8 cursor-pointer"
              }, null, 8, ["icon"])
            ]))
      ], 2),
      (constructionToChoose.value.length >= 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(constructionToChoose.value, (construction, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "w-full h-20 rounded flex flex-col my-2 first:mt-0 last:mb-0 p-1",
                onClick: ($event: any) => (setConstruction(construction)),
                key: index
              }, [
                _createElementVNode("label", _hoisted_10, _toDisplayString(construction.name), 1),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("label", null, _toDisplayString(construction.zip) + " ", 1),
                  _createElementVNode("label", null, _toDisplayString(construction.city) + ", ", 1),
                  _createElementVNode("label", null, _toDisplayString(construction.country), 1)
                ])
              ], 8, _hoisted_9))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(addProjectStore).errorResponse.construction, (errorMsg, index) => {
        return (_openBlock(), _createElementBlock("p", {
          class: "text-red-500",
          key: index
        }, _toDisplayString(errorMsg), 1))
      }), 128))
    ])
  ], 64))
}
}

})